import directive from './directives'

const importDirective = app => {
  /**
   * 拖拽指令 v-draggable="options"
   * options = {
   *  trigger: /这里传入作为拖拽触发器的CSS选择器/,
   *  body:    /这里传入需要移动容器的CSS选择器/,
   *  recover: /拖动结束之后是否恢复到原来的位置/
   * }
   */
  //  Vue.directive('draggable', directive.draggable)
  /**
   * clipboard指令 v-clipboard="options"
   * options = {
   *  value:    /在输入框中使用v-model绑定的值/,
   *  success:  /复制成功后的回调/,
   *  error:    /复制失败后的回调/
   * }
   */
  app.directive('clipboard', directive.clipboard)

  /**
   * 权限指令
   * optaion={
   *  权限code
   * }
   */
  app.directive('p', directive.permission)

  /**
   *throttle指令 v-throttle:500="handleClick"
   * options = {
   * }
   */
  app.directive('throttle', directive.throttle)
}

export default importDirective